import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { ProactiveChatEffects } from './proactive-chat.effects';
import { ProactiveChatActions } from './proactive-chat.actions';
import { WindowStateActions } from '../window/window.actions';
import { WindowMessagesActions } from '../window-messages/window-messages.actions';

export const initialState: Readonly<ProactiveChatConfig> = {
  engagements: [],
  currentIndex: -1,
};

export const proActiveChatFeature = createFeature({
  name: 'proactiveChat',
  reducer: createReducer(
    initialState,
    on(
      ProactiveChatActions.checkProactiveConfig,
      (state, { proactiveChatConfig }) => {
        return proactiveChatConfig;
      }
    ),
    on(ProactiveChatActions.showProactive, (state) => {
      return {
        ...state,
        currentIndex: state.currentIndex + 1,
      };
    }),
    on(
      WindowStateActions.requestToOpenWindow,
      WindowMessagesActions.initializeApp,
      (state) => {
        return {
          ...state,
          engagements: [],
          currentIndex: -1,
        };
      }
    )
  ),
});

export const { selectProactiveChatState } = proActiveChatFeature;

export function provideProactiveChatFeature() {
  return makeEnvironmentProviders([
    provideState(proActiveChatFeature),
    provideEffects(ProactiveChatEffects),
  ]);
}
